import { handleActions, combineActions } from "redux-actions";

import {
	getCommunityLeadersAsyncAction,
	getCommunityLeaderAsyncAction,
	updateCommunityLeaderStatusAsyncAction,
	getCommunityLeadersStatsAsyncAction,
	getCommunityLeadersRegionsAsyncAction,
} from "./communityLeaderActions";

const initialState = {
	list: {
		items: [],
		meta: {
			currentPage: 0,
			totalPages: 0,
		},
	},

	stats: [
		{
			month_1:1,
			month_2:2,
			month_3:3,
		}
	],

	regions:[
		{
			Area:"",
			TotalRegionalTournament: 0,
			TotalReportedTournament: 0,
			TotalTournament: 0,
		}
	],

	detail: {
		status: "",
		user: {},
	},

	fetch: {
		loading: false,
		error: "",
	},

	action: {
		loading: false,
		success: false,
		error: "",
	},
};

export const communityLeaderReducer = handleActions(
	new Map([
		[
			getCommunityLeadersAsyncAction.request,
			(state) => ({
				...state,
				fetch: {
					...initialState.fetch,
					loading: true,
				},
			}),
		],
		[
			getCommunityLeadersAsyncAction.success,
			(state, { payload }) => ({
				...state,
				fetch: {
					...initialState.fetch,
				},
				list: payload,
			}),
		],
		[
			getCommunityLeadersStatsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				fetch: {
					...initialState.fetch,
				},
				stats: payload.items,
			}),
		],
		[
			getCommunityLeadersRegionsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				fetch: {
					...initialState.fetch,
				},
				regions: payload,
			}),
		],
		[
			getCommunityLeaderAsyncAction.success,
			(state, { payload }) => ({
				...state,
				detail: payload,
			}),
		],
		[
			combineActions(
				updateCommunityLeaderStatusAsyncAction.request,
				getCommunityLeadersAsyncAction.request
			),
			(state) => ({
				...state,
				action: {
					...initialState.action,
					loading: true,
				},
			}),
		],
		[
			updateCommunityLeaderStatusAsyncAction.success,
			(state, { payload }) => ({
				...state,
				action: {
					...initialState.action,
					success: payload,
				},
			}),
		],
	]),
	initialState
);
